import { FC } from 'react';

interface NextIconProps {
  className: string;
  pathFillColor?: string;
}
export const NextIcon: FC<NextIconProps> = ({ className, pathFillColor = '#1A73E8' }) => {
  return (
    <div className={className}>
      <svg width="34" height="34" viewBox="8 4 30 30" xmlns="http://www.w3.org/2000/svg">
        <circle cx="23" cy="19" r="15" fill="white" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.06 14.644C16.8117 14.8908 16.673 15.2268 16.673 15.577C16.673 15.9273 16.8117 16.2632 17.06 16.5107C17.8902 17.341 18.7197 18.1705 19.55 19.0008L17.06 21.4915C16.8117 21.739 16.673 22.075 16.673 22.4253C16.673 22.7755 16.8117 23.1115 17.06 23.359C17.3075 23.6073 17.6435 23.746 17.9937 23.746C18.344 23.746 18.68 23.6073 18.9275 23.359C20.0705 22.2153 21.2142 21.0715 22.358 19.9285C22.6062 19.681 22.745 19.345 22.745 18.9948C22.745 18.6445 22.6062 18.3085 22.358 18.061L18.941 14.6448C18.4212 14.1273 17.5805 14.1273 17.06 14.6448V14.644ZM21.8142 10.6705C21.5667 10.918 21.4272 11.254 21.4272 11.6043C21.4272 11.9545 21.5667 12.2905 21.8142 12.538C23.969 14.692 26.123 16.846 28.277 19.0008C26.123 21.1548 23.969 23.3088 21.8142 25.4628C21.566 25.7103 21.4265 26.0463 21.4265 26.3973C21.4265 26.7475 21.566 27.0835 21.8142 27.331C22.0617 27.5793 22.3978 27.718 22.748 27.718C23.0983 27.718 23.4342 27.5793 23.6818 27.331C26.1493 24.8635 28.6175 22.3953 31.0857 19.9277C31.3332 19.6802 31.4728 19.3443 31.4728 18.994C31.4728 18.6438 31.3332 18.3078 31.0857 18.0603L23.6818 10.6577C23.1785 10.1545 22.3317 10.1545 21.8142 10.6705Z"
          fill={pathFillColor}
        />
      </svg>
    </div>
  );
};
